export default __webpack_public_path__ + "static/media/headerBG.fceb0608.png";